import { getRoleDisplayName } from '@/globals/typescript/utils/roleUtils'
import { LabCustomerUserBusiness as _LabCustomerUserBusiness } from '@team-milva/lab-models/user'

export class LabCustomerUserBusiness extends _LabCustomerUserBusiness {
  constructor(params: Partial<_LabCustomerUserBusiness> = {}) {
    super(params)
  }

  get mainRoleDisplayName(): string {
    return getRoleDisplayName(this.mainRole)
  }
}
